/*
This view contains commented out code for opening bill/invoice forms.
The forms are currently not functional and are temporarily commented out, until we figure out whether to remove the whole view, only this functionality, or fix it.
Not used anywhere aside from bank_sync_react view.
*/
import { PopOver } from '@components-deprecated'

import { Color, Text } from '@billy/design-system'

/* import { Link } from '@billy/design-system' */
import { css } from '@emotion/core'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { SpecificState } from '../../../../types/reduxSaga-deprecated'
import { reactClass } from '../../../../utils'
import { selectBankLineMatch } from '../../selectors'
import { Difference, ExtendedBankLineMatch } from '../../types'
import { CreateBillForm } from '../CreateBillForm'
import { CreateInvoiceForm } from '../CreateInvoiceForm'
import * as Styled from './styles'

export type MatchedPlaceholderProps = {
  difference: Difference
  matchId: string
  isDraggingOver?: boolean
}

export const MatchedPlaceholder = ({ isDraggingOver, matchId, difference, ...rest }: MatchedPlaceholderProps) => {
  const [isOpen, setOpen] = useState(false)
  const { amount, differenceAmount } = difference
  const { t } = useTranslation()
  const bankLineMatch = useSelector((state: SpecificState) =>
    selectBankLineMatch(state, matchId),
  ) as ExtendedBankLineMatch

  const isPositiveAmount = differenceAmount ? differenceAmount > 0 : amount > 0

  /*   const toggleOpen = () => setOpen(!isOpen) */
  const handleClose = () => setOpen(false)

  return (
    <Styled.MatchedPlaceholderContainer className={reactClass('bankline-placeholder')}>
      <Text variant="bodySM" color={Color.Black}>
        {/* <Link onClick={toggleOpen}>{isPositiveAmount ? t('create_invoice') : t('create_bill')}</Link> */}
        {` ${t('bankreconciliation.matchplaceholder.or_click_here')}`}
      </Text>
      <Styled.MatchedPlaceholderOverlay isDraggingOver={isDraggingOver} />
      {isOpen && (
        <PopOver
          isOpen={isOpen}
          onClose={handleClose}
          css={css`
            position: absolute;
            top: -1px;
            left: -1px;
            right: -1px;
            max-width: none;
            margin-left: 0 !important;
            z-index: 2;
          `}
        >
          {isPositiveAmount ? (
            <CreateInvoiceForm bankLineMatch={bankLineMatch} onClose={handleClose} />
          ) : (
            <CreateBillForm bankLineMatch={bankLineMatch} onClose={handleClose} />
          )}
        </PopOver>
      )}
    </Styled.MatchedPlaceholderContainer>
  )
}
